import React, { useState } from "react";
import "./SideBar.scss";
import SideBarBtn from "../Components/SideBarBtn";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import CmBtn from "../Components/CmBtn";
import { logoutFun } from "../Toolkit/AuthSlice";
import { useNavigate } from "react-router-dom";
import { sendReportFun } from "../Toolkit/SendReportSlice";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Typography,
} from "@mui/material";
import {
  AlignHorizontalSpaceAround,
  Clock9,
  FileSpreadsheet,
  LayoutDashboard,
  LogOut,
  User,
  Users,
} from "lucide-react";

const SideBar = () => {
  const currentUserRole = useSelector(
    (prev) => prev?.auth.currentUser?.data?.roles
  );
  const [open, setOpen] = useState(false);
  const [openTwo, setOpenTwo] = useState(false);
  const userEmail = useSelector((prev) => prev?.auth?.currentUser?.data?.email);
  const adminRole = currentUserRole?.includes("ADMIN");
  const frontDeskRole = currentUserRole?.includes("FRONT_DESK");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const lastIndex = location?.pathname?.split("/");

  const navItems = [
    {
      title: "Dashboard",
      url: "dashboard",
      icon: <LayoutDashboard />,
    },
    ...(adminRole
      ? [
          {
            title: "Users",
            url: "users",
            icon: <User />,
          },
          {
            title: "Reports",
            url: "reports",
            icon: <FileSpreadsheet />,
          },
          // {
          //   title: "Monthly report",
          //   url: "monthly-report",
          //   icon: <FileSpreadsheet />,
          // },
          {
            title: "Visitors",
            url: "visitors",
            icon: <Users />,
          },
        ]
      : []),
    ...(frontDeskRole
      ? [
          {
            title: "Visitors",
            url: "visitors",
            icon: <Users />,
          },
        ]
      : []),
         
  ];

  console.log("dskbcjsdgvuc", currentUserRole);



  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenTwo(false);
    setOpen(false);
  };

  let date = new Date();

  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");

  let formattedDate = `${year}-${month}-${day}`;

  const data = {
    email: userEmail,
    localDate: formattedDate,
  };

  const sendReportFunction = async () => {
    if (window.confirm("Are you want to Send Your Report ?") == true) {
      const logoutTimeResponse = await dispatch(sendReportFun(data));
      if (logoutTimeResponse.type === "send-report-data-urls/rejected")
        return setOpenTwo(true);
      setOpen(true);
      window.location.reload();
    }
  };


  const logoutUser = () => {
    if (window.confirm("Are you sure for Logout?") == true) {
      const key = localStorage.getItem("persist:root");
      dispatch(logoutFun());
      dispatch(sendReportFun(data))
      const token = localStorage.removeItem(key);
      navigate("/login");
    }
  };

  console.log("dfjbdsjhskdjh", location?.pathname?.split("/"));

  return (
    <div className="sidebar-data">
      <Snackbar open={openTwo} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Report Not Send Succesfully!
        </Alert>
      </Snackbar>

      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Report Send Succesfully!
        </Alert>
      </Snackbar>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "4px 8px",
          color: "#131313",
        }}
      >
        <Clock9 />
        <h2>Workplus</h2>
      </div>

      <MenuList>
        {navItems?.map((item) => {
          return (
            <Link
              style={{
                textDecoration: "none",
              }}
              to={item?.url}
              key={item?.url}
            >
              <MenuItem
                sx={{
                  backgroundColor:
                    lastIndex?.[lastIndex.length - 1] === item?.url
                      ? "rgba(0, 0, 0, 0.04)"
                      : "",
                }}
              >
                <ListItemIcon>{item?.icon}</ListItemIcon>
                <ListItemText
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "rgb(86,81,81)",
                    }}
                  >
                    {item?.title}
                  </Typography>
                </ListItemText>
              </MenuItem>
            </Link>
          );
        })}
        <Divider />
        <MenuItem>
          <ListItemIcon>
            <LogOut />
          </ListItemIcon>
          <ListItemText
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Link
              style={{
                textDecoration: "none",
                fontWeight: "bold",
                color: "rgb(86,81,81)",
              }}
              onClick={logoutUser}
            >
              Logout
            </Link>
          </ListItemText>
        </MenuItem>
      </MenuList>

      {/* <div className="side-buttons mt-4">
        <SideBarBtn
          linkPath={``}
          name="My Workplus Time"
          icon={<i className="fa-solid fa-desktop"></i>}
        />
        {adminRole ? (
          <>
            <SideBarBtn
              linkPath={`screenshot`}
              name="Screen Shot"
              icon={<i className="fa-regular fa-image"></i>}
            />
            <SideBarBtn
              linkPath={`users`}
              name="Users"
              icon={<i className="fa-solid fa-user"></i>}
            />
            <SideBarBtn
              linkPath={`reports`}
              name="Reports"
              icon={<i className="fa-regular fa-file-word"></i>}
            />
            <SideBarBtn
              linkPath={`monthly-report`}
              name="Monthly Report"
              icon={<i className="fa-regular fa-file-word"></i>}
            />
            <SideBarBtn
              linkPath={`ipaddress`}
              name="IP"
              icon={<i className="fa-solid fa-mobile-screen-button"></i>}
            />
            <SideBarBtn
              linkPath={`userlist`}
              name="User List Gap"
              icon={<i className="fa-solid fa-users"></i>}
            />
            <SideBarBtn
              linkPath={`visitors`}
              name="Visitors"
              icon={<i className="fa-solid fa-users"></i>}
            />
          </>
        ) : frontDeskRole ? (
          <SideBarBtn
            linkPath={`visitors`}
            name="Visitors"
            icon={<i className="fa-solid fa-users"></i>}
          />
        ) : (
          ""
        )}

        <SideBarBtn
          linkPath={`gap`}
          name="Gap"
          icon={<i className="fa-solid fa-arrows-left-right-to-line"></i>}
        />
        <CmBtn
          className="side-btn hover-w"
          onClick={sendReportFunction}
          data={`Send Report`}
          icon={<i className="fa-solid mr-2 fa-share-from-square"></i>}
        />
        <CmBtn
          className="side-btn hover-w"
          onClick={logoutUser}
          data={`Logout`}
          icon={<i className="fa-solid mr-2 fa-right-from-bracket"></i>}
        />
      </div> */}
    </div>
  );
};

export default SideBar;
